// Generated by Melange

import * as JsxRuntime from "react/jsx-runtime";

function LegalSecurityPage(Props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h3", {
        children: "Политика информационной безопасности ТОО «Бухта»",
        className: "h4 lg:h3 text-black-landing"
      }),
      JsxRuntime.jsx("h5", {
        children: "Назначение документа",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("p", {
        children: [
          JsxRuntime.jsx("span", {
            children: "Политика информационной безопасности",
            className: "font-medium"
          }),
          " (далее - Политика) предназначена для определения\nцелей и требований обеспечения информационной безопасности ТОО «Бухта».\nПод обеспечением информационной безопасности или защитой информации понимается\nсохранение ее конфиденциальности, целостности и доступности. Конфиденциальность\nинформации обеспечивается предоставлением доступа к информационным ресурсам только\nавторизованным пользователям, целостность – обеспечивается в случае внесения изменений в\nданные авторизованными пользователями, доступность – в обеспечении возможности доступа к\nинформационным ресурсам авторизованным пользователям в нужное для них время."
        ],
        className: "paragraph text-black-landing mt-2"
      }),
      JsxRuntime.jsx("h5", {
        children: "Основные термины и определения:",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ol", {
        children: [
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Товарищество",
                  className: "font-medium"
                }),
                " – товарищество с ограниченной ответственностью «Бухта»;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Информационная безопасность (далее ИБ)",
                  className: "font-medium"
                }),
                " – комплекс правовых, технических и\nорганизационных мероприятий, направленных на обеспечение защиты информационных\nресурсов от несанкционированного доступа, искажения и уничтожения, для, обеспечение\nконфиденциальности, целостности и доступности информации;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Отдел информационных технологий (далее ОИТ)",
                  className: "font-medium"
                }),
                " – структурное подразделение\nТоварищества, имеющее компетенцию в данной области, осуществляющее системно-\nтехническое обслуживание информационных систем;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Информационная система (далее ИС)",
                  className: "font-medium"
                }),
                " – совокупность информационно-коммуникационных\nтехнологий, обслуживающего персонала и технической документации, реализующих\nопределенные технологические действия посредством информационного взаимодействия и\nпредназначенных для решения конкретных функциональных задач;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Электронные информационные ресурсы (далее ЭИР)",
                  className: "font-medium"
                }),
                " – информация, хранимая в электронном\nвиде (информационные базы данных), содержащаяся в информационных системах;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Администратор ИС",
                  className: "font-medium"
                }),
                " – работник Товарищества, ответственный за администрирование,\nсопровождение и обеспечение бесперебойного функционирования ИС Товарищества;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Пользователь ИС",
                  className: "font-medium"
                }),
                " – субъект информатизации, использующий объекты информатизации для\nвыполнения конкретной функции и(или) задачи;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "База данных",
                  className: "font-medium"
                }),
                " – совокупность связанных данных, организованных по определенным правилам,\nпредусматривающим общие принципы описания, хранения и манипулирования, независимая от\nприкладных программ. База данных является информационной моделью предметной области;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Конфиденциальность информации",
                  className: "font-medium"
                }),
                " – обеспечение предоставления информации только\nавторизованным лицам;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Целостность информации",
                  className: "font-medium"
                }),
                " – состояние информации (информационных ресурсов\nавтоматизированной информационной системы), при котором её(их) изменение осуществляется\nтолько авторизованными пользователями;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Доступность",
                  className: "font-medium"
                }),
                " – обеспечение возможности доступа авторизованным пользователям к\nинформационным ресурсам автоматизированной информационной системы в нужное время.\nНастоящий документ разработан в соответствии с нормативно-правовыми актами и\nдокументами Республики Казахстан и международными стандартами."
              ],
              className: "paragraph text-black-landing"
            })
          })
        ],
        className: "list-decimal mt-2"
      }),
      JsxRuntime.jsx("h5", {
        children: "Цели и задачи обеспечения ИБ",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ol", {
        children: [
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Целью обеспечения информационной безопасности является предотвращение и минимизация\nвозможного ущерба от реализации угроз информационной безопасности, а также повышение\nобщего уровня конфиденциальности, целостности и доступности информационных ресурсов\nТоварищества. Задачами обеспечения ИБ являются:",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Обеспечение непрерывности деятельности Товарищества, управление рисками в целях\nнедопущения или снижения вероятности возникновения внештатных ситуаций, выявление и\nнедопущение нарушений, а также условий для их реализации;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Создание механизма оперативного мониторинга и реагирования на нарушения.",
              className: "paragraph text-black-landing"
            })
          })
        ],
        className: "list-decimal mt-2",
        start: 12
      }),
      JsxRuntime.jsx("h5", {
        children: "Основные принципы обеспечения ИБ",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ol", {
        children: [
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Основным принципом является защита ИС и ЭИР Товарищества от возможного нанесения ущерба посредством несанкционированного вмешательства в процесс функционирования.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Защита ИС и ЭИР Товарищества достигается посредством обеспечения и постоянного\nподдержания доступности, конфиденциальности и целостности информации.",
              className: "paragraph text-black-landing"
            })
          })
        ],
        className: "list-decimal mt-2",
        start: 15
      }),
      JsxRuntime.jsx("h5", {
        children: "Область распространения",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ol", {
        children: [
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Действие настоящей Политики распространяется на все структурные подразделения Товарищества, а также подрядной организации при её наличии и учитывается в договорных\nотношениях поставщиками услуг.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Настоящая Политика применяется ко всем работникам Товарищества, подрядной организации\nпри ее наличии, ко всем информационным технологиям и телекоммуникационным ресурсам,\nиспользуемым в Товариществе, а также ко всем помещениям, в которых пользователь может\nполучить доступ к ИС и информационно-коммуникационной инфраструктуре Товарищества.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "В целях обеспечения выполнения содержащихся в Политике нормативных правил необходимо\nобеспечить ее соблюдение третьими сторонами.",
              className: "paragraph text-black-landing"
            })
          })
        ],
        className: "list-decimal mt-2",
        start: 17
      }),
      JsxRuntime.jsx("h5", {
        children: "Распределение обязанностей по обеспечению ИБ",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ol", {
        children: [
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Руководство Товарищества совместно с ОИТ и Ответственными за ИБ обязано активно\nреализовывать комплекс мероприятий по поддержанию ИС и ЭИР Товарищества посредством\nпредоставления ясных указаний, демонстрируемых обязательств, четких постановок задач и\nосведомленности работников об обязанностях по обеспечению ИБ.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Ответственный за ИБ обеспечивает формирование и контроль выполнения всех пунктов\nданной политики, должен пересматривать эффективность реализации политики ИБ и обеспечить\nчеткое управление и зримую поддержку инициатив в области поддержки Системы управления\nинформационной безопасностью, совместно с ОИТ должен инициировать планы и программы\nпо поддержанию осведомленности об ИБ.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Руководство должно обеспечивать координацию мер контроля за ИБ в Товариществе,\nпредоставлять ресурсы для обеспечения ИБ, должно утверждать распределение специфических\nролей и обязанностей по ИБ",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Администраторы ИС Товарищества обязаны действовать в строгом соответствии с\nзонами их ответственности, согласно Руководству администратора ИС Товарищества.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Пользователи ИС Товарищества обязаны действовать в строгом соответствии с зонами их\nответственности, согласно своим должностным обязанностям, учётных ролей в ИС и\nРуководству пользователя ИС Товарищества.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Ответственный за ИБ отвечает за руководство разработкой, анализом Политики ИБ\nТоварищества.",
              className: "paragraph text-black-landing"
            })
          })
        ],
        className: "list-decimal mt-2",
        start: 20
      }),
      JsxRuntime.jsx("h5", {
        children: "Координация ИБ",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ol", {
        children: [
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Действия по обеспечению ИБ должны координироваться руководством Товарищества\nсоответствии с их компетенцией и должностным положением . Эта деятельность должна:",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Обеспечивать соответствие выполнения мероприятий по обеспечению ИБ;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Определять мероприятия по обеспечению ИБ в случае ее несоответствия политике ИБ;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Утверждать методологии и процессы обеспечения ИБ, например, оценку рисков,\nклассификацию информации;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Идентифицировать все изменения угроз ИБ и степень уязвимости информации и средств\nобработки информации к угрозам ИБ;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Оценивать адекватность принимаемых решений и координировать реализацию мер контроля\nИБ;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Повышать профессиональный уровень пользователей за счёт обучения, подготовке по ИБ и\nосведомленности о ней;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Оценивать информацию, полученную от мониторинга и просмотра инцидентов по ИБ и\nрекомендовать соответствующие мероприятия в ответ на идентифицированные инциденты ИБ.",
              className: "paragraph text-black-landing"
            })
          })
        ],
        className: "list-decimal mt-2",
        start: 26
      }),
      JsxRuntime.jsx("h5", {
        children: "Обучение и осведомленность в вопросах ИБ",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ol", {
        children: [
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Требования к обучению и осведомленности в вопросах ИБ:",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Пользователи, сотрудники ОИТ и администраторы ИС",
                  className: "font-medium"
                }),
                " Товарищества должны быть\nознакомлены с политикой ИБ и соблюдать ее требования;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Ответственный за ИБ",
                  className: "font-medium"
                }),
                " Товарищества должен проводить первичный инструктаж по ИБ;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: "Сотрудники ОИТ и Администратор ИС",
                  className: "font-medium"
                }),
                " Товарищества, обеспечивающие функционирование\nИС Товарищества должны проходить регулярный инструктаж по соблюдению требований ИБ;"
              ],
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "В целях обеспечения ИБ необходимо согласовать и определить в соглашении с третьей стороной мероприятия по управлению ИБ Товарищества;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Ответственный за ИБ по мере необходимости проходит курсы по повышению квалификации\nпо информационной безопасности;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "В целях обеспечения гарантированного уведомления ответственным за ИБ, всех\nзаинтересованных сторон об инциденте и уязвимости ИБ по отношению к ИС\nТоварищества должны быть реализованы формальные процедуры по уведомлению об\nинциденте и проявлении угроз. Для трансляции уведомлений должен быть избран\nспособ, гарантированно позволяющий своевременно принять корректирующие меры по\nсохранению ИБ;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Ответственный за ИБ Товарищества должен знать процедуры уведомления, а также располагать\nсведениями о различных типах событий или слабых местах, которые могут влиять на\nбезопасность ресурсов, о наступлении которых или предпосылках к таковым необходимо\nотправить уведомление;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Сотрудники ОИТ и Администраторы ИС Товарищества обязаны как можно быстрее сообщать\nлюбых нарушениях в сфере ИБ ответственному за ИБ лицу;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Ответственные лица по ИБ должны вести мониторинг посещения серверного помещения за\nсотрудниками ОИТ.",
              className: "paragraph text-black-landing"
            })
          })
        ],
        className: "list-decimal mt-2",
        start: 34
      }),
      JsxRuntime.jsx("h5", {
        children: "Управление инцидентами",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ol", {
        children: [
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "В случае обнаружения нарушения информационной безопасности следует незамедлительно\nдоложить ответственному по ИБ.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Все сотрудники, подрядчики и пользователи, пользующиеся ИС и ЭИР Товарищества обязаны\nнезамедлительно доложить об инциденте ответственному по ИБ и по возможности обеспечить\nминимизацию ущерба.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "В случае возникновения инцидента ИБ или другой нештатной ситуации необходимо\nруководствоваться «Инструкцией о порядке действий пользователей по реагированию на\nинциденты ИБ во внештатных (кризисных) ситуациях».",
              className: "paragraph text-black-landing"
            })
          })
        ],
        className: "list-decimal mt-2",
        start: 44
      }),
      JsxRuntime.jsx("h5", {
        children: "Управление непрерывностью бизнеса",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ol", {
        children: [
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Необходимо внедрить процесс управления непрерывностью бизнеса с целью минимизации\nвлияния на деятельность Товарищества и восстановления после потери информационных\nактивов. Этот процесс должен идентифицировать важные бизнес-процессы и интегрировать\nтребования непрерывности бизнеса управления информационной безопасностью с другими\nтребованиями непрерывности касательно таких аспектов, как операции, кадровое обеспечение,\nматериалы, транспорт и оборудование.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Последствия нарушений безопасности, отказов в обслуживании и доступность сервисов должны\nбыть предметом анализа степени влияния на бизнес. Информационная безопасность является\nсоставной частью общего процесса непрерывности бизнеса, и других процессов управления в\nорганизации, для идентификации и уменьшения рисков.",
              className: "paragraph text-black-landing"
            })
          })
        ],
        className: "list-decimal mt-2",
        start: 47
      }),
      JsxRuntime.jsx("h5", {
        children: "Анализ и оценка рисков",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ol", {
        children: [
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Требования к анализу и оценке рисков:",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Политика ИБ Товарищества основывается на данных, полученных в результате анализа и оценки\nрисков ИБ;",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "С целью совершенствования политики информационной безопасности Товарищества,\nпроводиться ежегодный анализ и оценка рисков информационной безопасности для ИС и ЭИР\nТоварищества в соответствии со стандартами, действующими на территории Республики\nКазахстан и международными регламентами;",
              className: "paragraph text-black-landing"
            })
          })
        ],
        className: "list-decimal mt-2",
        start: 49
      }),
      JsxRuntime.jsx("h5", {
        children: "Контроль изменений",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsx("ol", {
        children: JsxRuntime.jsx("li", {
          children: JsxRuntime.jsx("p", {
            children: "В целях минимизации влияния инцидентов, связанных с изменениями, на качество\nпредоставляемых услуг, работоспособности ИС, используются стандартные методы и\nпроцедуры для продуктивной и своевременной обработки изменений, прописанные в\nПоложении об управлением изменением товарищества.",
            className: "paragraph text-black-landing"
          })
        }),
        className: "list-decimal mt-2",
        start: 52
      }),
      JsxRuntime.jsx("h5", {
        children: "Пересмотр политики ИБ",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ol", {
        children: [
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Товарищество является владельцем Политики ИБ. Пересмотр политики ИБ производится не\nреже одного раза в год и должен включать возможности оценки для улучшения в ответ на\nизменения в организационной среде, деловой ситуации, юридических условиях или технической\nсреде.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Пересмотренная политика и все технические документы по информационной безопасности\nдолжны утверждаться руководством.",
              className: "paragraph text-black-landing"
            })
          })
        ],
        className: "list-decimal mt-2",
        start: 53
      }),
      JsxRuntime.jsx("h5", {
        children: "Ответственность и контроль эффективности политики информационной безопасности",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsxs("ol", {
        children: [
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Для обеспечения необходимого уровня информационной безопасности Товарищество\nпроизводит постоянный контроль эффективности.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "Руководство несет ответственность за выполнение всех пунктов данной политики.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "За Планирование и контроль состояния информационной безопасности в Товариществе несет\nответственность Ответственный за ИБ сотрудник.",
              className: "paragraph text-black-landing"
            })
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx("p", {
              children: "В случае нарушения требований настоящей Политики ИБ все субъекты Товарищества\nпривлекаются к административной или иной ответственности в соответствии с действующим\nзаконодательством Республики Казахстан.",
              className: "paragraph text-black-landing"
            })
          })
        ],
        className: "list-decimal mt-2",
        start: 55
      })
    ],
    className: "flex m-auto flex-col py-10 lg:py-30 px-6 sm:px-48 lg:px-0 lg:w-252"
  });
}

const make = LegalSecurityPage;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
